import React from 'react';
import NumberMarquee from '../common/NumberMarquee';
import {productionNumbers} from '../../data/production';
import styled from 'styled-components';

const ProductionScroller = styled.div`
	margin-top: 5em;
	border-bottom: 0.02em solid #403d3d;

	.marquee {
		align-items: flex-end;
	}

    @media screen and (max-width: 650px) { 
	    margin-top: 8em;
    }
`;

const ProductionScroll = () => {
	return (
		<ProductionScroller>
			<NumberMarquee list={productionNumbers} direction="left" />
		</ProductionScroller>
	);
};

export default ProductionScroll;
